const track10sVisibility = (element, trackingObj) => {
  let timer = null
  const timeout = 10000
  const startTimer = (callback) => {
    timer = setTimeout(() => {
      window.dataLayer.push(trackingObj)
      if (callback) {
        callback()
      }
    }, timeout)
  }

  const options = {
    root: null,
    rootMargin: '0px 0px 0px 0px',
    threshold: 0.5
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        startTimer(() => {
          observer.unobserve(entry.target)
        })
      } else {
        clearInterval(timer)
      }
    })
  }, options)

  observer.observe(element)
}
export default track10sVisibility
